document.addEventListener('DOMContentLoaded', () => {
  const toBool = (value) => {
    if (value === true || value === 'true' || value === '1') return true;
    if (value === false || value === 'false' || value === '0' || value == null) return false;
    const str = String(value).trim().toLowerCase();
    return str === 'true' || str === '1';
  };

  const toInt = (value, defaultValue) => {
    if (value == null || value === '') return defaultValue;
    const n = parseInt(value, 10);
    return Number.isFinite(n) ? n : defaultValue;
  };

  const sections = document.querySelectorAll('[data-section-type="slider-scratches--icons"]');
  if (!sections.length) return;

  sections.forEach((section) => {
    const mediaSwiperEl = section.querySelector('.slider-scratches--icons__media-swiper');
    const contentSwiperEl = section.querySelector('.slider-scratches--icons__content-swiper');
    
    if (!mediaSwiperEl || !contentSwiperEl) return;
    if (mediaSwiperEl.classList.contains('slider-scratches--icons--inited')) return;

    const speed = toInt(section.dataset.speed, 600);
    const autoplayEnabled = toBool(section.dataset.autoplay);
    const delay = toInt(section.dataset.delay, 4000);
    const effect = section.dataset.effect || 'slide';

    const paginationEl = section.querySelector('.slider-scratches--icons__pagination');

    const commonOptions = {
      loop: true,
      speed,
      effect,
      slidesPerView: 1,
      spaceBetween: 0,
      mousewheel: { forceToAxis: true },
      grabCursor: true,
      autoHeight: false,
    };

    const mediaOptions = {
      ...commonOptions,
      allowTouchMove: true,
    };

    const contentOptions = {
      ...commonOptions,
      effect: 'slide', // Force slide effect for content to avoid overlap issues if main is fade/cube
      pagination: paginationEl ? { el: paginationEl, clickable: true } : undefined,
      allowTouchMove: true,
    };

    if (autoplayEnabled) {
      mediaOptions.autoplay = { delay, disableOnInteraction: false };
    }

    try {
      const mediaSwiper = new Swiper(mediaSwiperEl, mediaOptions);
      const contentSwiper = new Swiper(contentSwiperEl, contentOptions);

      mediaSwiper.controller.control = contentSwiper;
      contentSwiper.controller.control = mediaSwiper;

      mediaSwiperEl.classList.add('slider-scratches--icons--inited');
      section.mediaSwiper = mediaSwiper;
      section.contentSwiper = contentSwiper;
    } catch (e) {
      console.error('Slider-scratches--icons init error:', e);
    }
  });
});